import React from "react";
import QPhototModuleSubtopic from "../../../QPhotoModuleSubtopic";

const GreensTheorem = () => (
  <QPhototModuleSubtopic
    title="Greens"
    videos={[
      "https://www.youtube.com/embed/Pzwste_W4Lg"
    ]}
    takeaways={[]}
    questions={[
        {
            image:"/cal_73.jpeg"
        },
        {
            image:"/cal_74.jpeg"
        },
        {
            image:"/cal_75.jpeg"
        },
        {
            image:"/cal_76.jpeg"
        }
    ]}
    exampleVideos={[]}
  />
);

export default GreensTheorem;
